import { render, staticRenderFns } from "./LinkitKavoniuksenJulkaisuihin.vue?vue&type=template&id=288d9347&scoped=true"
import script from "./LinkitKavoniuksenJulkaisuihin.vue?vue&type=script&lang=js"
export * from "./LinkitKavoniuksenJulkaisuihin.vue?vue&type=script&lang=js"
import style0 from "./LinkitKavoniuksenJulkaisuihin.vue?vue&type=style&index=0&id=288d9347&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288d9347",
  null
  
)

export default component.exports